export default __webpack_public_path__ + "images/f3ca640652be35c65a28f423db86b186-startup_small_business.jpg";